import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/v1/stock-return-vendors', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const find = (id, Options = {}) => {
  return httpClient
    .get(`/api/v1/stock-return-vendors/${id}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/v1/stock-return-vendors', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const stockInByNumber = data => {
  return httpClient
    .post('/api/v1/stock-return-vendors/stock-in-by-number', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = (id, data) => {
    return httpClient
      .put(`/api/v1/stock-return-vendors/${id}`, data)
      .then(response => Promise.resolve(response.data))
      .catch(error => Promise.reject(error.response.data))
}

export const destroy = id => {
    return httpClient
      .delete(`/api/v1/stock-return-vendors/${id}`)
      .then(response => Promise.resolve(response.data))
      .catch(error => Promise.reject(error.response.data))
}

export const setRefundReceived = id => {
    return httpClient
      .get(`/api/v1/stock-return-vendors/${id}/is-received-refund`)
      .then(response => Promise.resolve(response.data))
      .catch(error => Promise.reject(error.response.data))
}

export const status = () => {
    return httpClient
    .get('/api/v1/stock-return-vendors/return-status')
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data)) 
}

export const vendor = () => {
    return httpClient
    .get('/api/v1/stock-return-vendors/vendor-list')
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data)) 
}

export const findBySerial = serial_number => {
    return httpClient
    .get(`/api/v1/stock-return-vendors/${serial_number}/products`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data)) 
}

export default { 
    get, 
    find,
    store,
    update,
    destroy,
    status,
    vendor,
    findBySerial,
    stockInByNumber,
    setRefundReceived
}